export default __webpack_public_path__ + "files/445dd2ab20befc4a78c9e77bc9fd260f.png";